import createLucideIcon from '../createLucideIcon';

const ArrowDownRight = createLucideIcon('ArrowDownRightIcon', [
  ['line', { x1: '7', y1: '7', x2: '17', y2: '17', key: 'dtegzv' }],
  ['polyline', { points: '17 7 17 17 7 17', key: '1gmiis' }],
]);

export default ArrowDownRight;
